import mixpanel from "mixpanel-browser";

let env_check = process.env.NODE_ENV === "production";

if (env_check) {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_KEY, {
    ignore_dnt: true,
    track_pageview: true,
    autocapture: true,
    record_sessions_percent: 100,
  });
}

let actions = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id) => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
};

export let Mixpanel = actions;
